import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Subscription } from 'rxjs';
import { AboutpageService } from 'src/app/features/company/about/aboutpage.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
export class CustomersComponent implements OnInit, OnDestroy {
  constructor(
    private contentful: ContentfulService,
    private aboutPageService: AboutpageService
  ) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  customersData: any;

  ngOnInit(): void {
    this.aboutPageService.aboutCustomers$.subscribe(data => {
      if (data != null) {
        this.customersData = {
          logos: data.image,
          stats: data.components2,
          title: data.title,
        };
      }
    });
  }
}
